import React from "react";
//#region types
import { FormFieldProps, CheckboxSelectionExtraProps } from "models/propTypes/genericFormProps";
import { SelectionItem } from "models/utilTypes/selectionTypes";
//#endregion
//#region components
import CheckboxSelection from "../../selection/checkboxSelection";
//#endregion

function CheckboxSelectionFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const { name, field, value, handleOnChangeCustom, handleOnBlurCustom, readonly } = props;

  const extraProps = field.extraProps as CheckboxSelectionExtraProps;

  React.useImperativeHandle(props.fieldRef, () => ({
    change: (selectedItems: SelectionItem[]) => {
      onChangeHandler(selectedItems);
    },
  }));

  const onChangeHandler = (selectedItems: SelectionItem[]) => {
    handleOnChangeCustom(name, selectedItems);
    handleOnBlurCustom(name);
  };

  return (
    <CheckboxSelection
      items={extraProps.items}
      value={value ?? []}
      onChange={onChangeHandler}
      className={field.classes?.input}
      readonly={readonly}
    />
  );
}

export default CheckboxSelectionFormField;
